import clone from "rfdc";

export const fastClone = clone({});
